import type {
  BooleanField,
  GeoPoint,
  NestableWidget,
  Separator,
  Table,
  UID,
} from "@prismicio/types-internal/lib/customtypes"

type Widgets = NestableWidget | UID
type Field = Exclude<Widgets, Separator | GeoPoint>

export function getFieldLabel(field: Widgets): string {
  if (field.config?.label) return field.config.label
  // fieldset is a legacy property, but we want to use it as a label if it exists.
  if (
    field.type !== "Boolean" &&
    field.type !== "Separator" &&
    field.type !== "Table" &&
    field.fieldset
  ) {
    return field.fieldset
  }
  return field.type
}

export const DEFAULT_PLACEHOLDER = "..."

export function getBooleanFieldPlaceholder(
  field: BooleanField,
  value: boolean,
  defaultPlaceholder = DEFAULT_PLACEHOLDER,
): string {
  return (
    (value
      ? field.config?.placeholder_true
      : field.config?.placeholder_false) || defaultPlaceholder
  )
}
export function getFieldPlaceholder(
  field: Exclude<Field, BooleanField | Table>,
  defaultPlaceholder = DEFAULT_PLACEHOLDER,
): string {
  return field.config?.placeholder || defaultPlaceholder
}
